import { gql } from "@apollo/client";

export const SEND_NOTIFICATION = gql`
  mutation SendNotification {
    sendNotification {
      successMessage
    }
  }
`;
